export const externalUrls = {
  letsTalk: 'https://www.boldpenguin.com/contact/lets-talk',
  exchangeMarketingPage:
    'https://www.boldpenguin.com/core-pages/request-a-demo',
  exchangeRequestADemo: 'https://www.boldpenguin.com/request-a-demo-exchange',
  jiraCreateBugPage:
    'https://boldpenguin.atlassian.net/servicedesk/customer/portal/7',
} as const;

export const baWorkflowUrls = {
  riskSelectionGuide:
    'https://brokeragealliances.amfam.com/brokeragealliances/pages/products/comm_lines-2.asp',
  acordLibrary:
    'https://brokeragealliances.amfam.com/brokeragealliances/pages/tools-AccordLibrary.asp',
  stateSpecificAcordLibrary:
    'https://brokeragealliances.amfam.com/brokeragealliances/pages/tools-AccordLibrary_StateSpecific.asp',
} as const;
